import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VExpansionPanels,[_c(VExpansionPanel,[_c(VExpansionPanelHeader,[_vm._t("title")],2),_c(VExpansionPanelContent,[_vm._t("content")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }